import React from 'react';
export const HeaderTitle = (props) => {
    const { title, subtitle } = props;
    return (React.createElement("div", { className: "tw-font-lato" },
        React.createElement("div", { className: "tw-text-base tw-text-gray-900 dark:tw-text-gray-100" }, title),
        subtitle && React.createElement("div", { className: "tw-text-xs tw-text-gray-600 dark:tw-text-gray-300 tw-mt-1" }, subtitle)));
};
//# sourceMappingURL=HeaderTitle.js.map